import React from "react";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { checkPasswordRules } from "../SignupnLogin/Validators/password";

/**
 * Live checklist of the password policy. Each rule turns green once the current
 * value satisfies it and stays red until then. The rules come from the shared
 * validator, so this can never disagree with what actually passes validation.
 */
function PasswordRules({ value, className = "" }) {
  const rules = checkPasswordRules(value);

  return (
    <ul className={`mt-2 space-y-1 text-sm ${className}`}>
      {rules.map(({ id, label, satisfied }) => (
        <li
          key={id}
          className={`flex items-center gap-x-2 ${
            satisfied ? "text-green-600" : "text-red-600"
          }`}
        >
          {satisfied ? (
            <CheckCircleIcon className="size-4 shrink-0" />
          ) : (
            <XCircleIcon className="size-4 shrink-0" />
          )}
          <span>{label}</span>
          <span className="sr-only">
            {satisfied ? "requirement met" : "requirement not met"}
          </span>
        </li>
      ))}
    </ul>
  );
}

export default PasswordRules;
